<!--<br>inputText={{inputText}}-->
<!--<br>inputPlaceholder={{inputPlaceholder}}-->
<!--<br>selModelText={{selModelText}}-->
<!--<div *ngIf="dropdownInput">value={{dropdownInput.value | json}}</div>-->
<!--pristine={{ngControl.pristine | json}}-->
<!--<br> jbModel={{jbModel | json}}-->
<!--<br> jbModel={{jbModel?.id + ' - ' + jbModel?.email}}-->
<!--<br> jbCandidate={{jbCandidate?.id + ' - ' +  jbCandidate?.email}}-->
<!--errors={{errors | json}}-->

<div class="form-group dropdown-form-group"
     (keydown)="triggerKey($event)"
     [class.is-required]="jbRequired"
     [class.is-disabled]="jbDisabled"
     [class.is-focus]="isFocus || isExpanded"
     [class.is-error]="showError">

  <label *ngIf="!!jbLabel" [class.is-required]="jbRequired">
    <span class="info-badge" *ngIf="!!jbTooltip"
         [ngbTooltip]="jbTooltipTrans$ | async" [placement]="jbTooltipPos" triggers="hover"
         [container]="(jbTooltipBody ? 'body' : '')">
      <span class="icon-info"></span>
    </span>
    <span>{{jbLabelTrans$ | async}}</span>:
    <span *ngIf="jbRequired" class="asterisk">*</span>
  </label>

  <!--Error Message-->
  <span *ngIf="showError && errorPosition !== 'none'"
        class="dropdown-error-text"
        [class.pull-up]="!jbLabel"
        [class.default]="errorPosition === 'default'"
        [class.top-right]="errorPosition === 'top-right'"
        [class.bottom-left]="errorPosition === 'bottom-left'"
        [class.bottom-right]="errorPosition === 'bottom-right'">
    {{errorTextTrans$ | async}}
  </span>


  <div class="dropdown" [class.is-expanded]="isExpanded" [class.expand-upward]="expandUpward">
    <div class="input-group"
         [disableTooltip]="!jbDisabled || !jbDisabledTip"
         [ngbTooltip]="jbDisabledTipTrans$ | async">

      <input type="text" class="form-control" #dropdownInput
             [(ngModel)]="inputText" (ngModelChange)="inputType($event)"
             [class.has-image]="!!jbModel?.$img"
             [class.has-icon]="!!jbModel?.$icon"
             [placeholder]="inputPlaceholder"
             [disabled]="jbDisabled"
             (focusin)="expandList()"
             (focusout)="collapseList()">

      <img *ngIf="!!jbModel?.$img" class="input-image" [class.fade]="isExpanded" [src]="jbModel?.$img" [alt]="jbModel?.$img">

      <span *ngIf="jbModel?.$icon && !jbModel?.$img" class="input-icon" [class.fade]="isExpanded"
            [ngClass]="jbModel?.$icon">
      </span>

      <div class="input-group-append" (click)="!jbDisabled && onInputBtnClick()">
        <button class="btn btn-outline-secondary" [disabled]="jbDisabled ? 'true' : ''" tabIndex="-1">
          <span [hidden]="isLoading" [ngClass]="(isExpanded && expandUpward) ? 'icon-arrow-up22' : 'icon-arrow-down22'"></span>
          <!--<span [hidden]="!isLoading" class="icon-loop32 loading"></span>-->
          <span [hidden]="!isLoading" class="loading"></span>
        </button>
      </div>
    </div>

    <div class="list-container" [class.list-upward]="expandUpward" *ngIf="isExpanded" #listContainer>
      <div *ngFor="let item of extList" class="option-wrapper">
        <div *ngIf="item.$groupHeader && !item.$hideHeader" class="group-header">{{item.$groupHeader}}</div>

        <div class="option-row" #optionRow
             [class.selected]="jbModel === item"
             [class.candidate]="jbCandidate === item"
             [class.group-pad]="!!jbGroupBy && !!item[jbGroupBy]"
             [hidden]="!item.$isMatch"
             (mouseenter)="!ignoreHover && (jbCandidate = item)"
             (mouseleave)="!ignoreHover && (jbCandidate = null)"
             (mousedown)="selectItem(item)">
          <img *ngIf="!!item?.$img"  class="option-row-image" [src]="item?.$img" [alt]="item?.$img">
          <span *ngIf="!!item?.$icon" class="option-row-icon" [ngClass]="item?.$icon"></span>
          <span *ngIf="jbHtmlRender" [innerHTML]="item.$renderedText"></span>
          <span *ngIf="!jbHtmlRender">{{item.$renderedText}}</span>
        </div>

      </div>
    </div>
  </div>



</div>

